/**
 * Tool utility functions for checking tool types and properties.
 */
/**
 * Check if a tool is an authentication tool based on its name.
 * Matches the logic from agent-handler-backend: agent_handler/tool_packs/utils.py
 *
 * @param toolName - The name of the tool to check
 * @returns true if the tool is an authentication tool, false otherwise
 */
export var isAuthenticateTool = function (toolName) {
    return toolName.startsWith("authenticate_") || toolName.endsWith("__authenticate");
};
